import {
    GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS,
    GETSUBADMINMANAGEMENTLISTADMIN_FAILED,
    RESET_GETSUBADMINMANAGEMENTLISTADMIN,
    LOADING_GETSUBADMINMANAGEMENTLISTADMIN,
    NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETSUBADMINMANAGEMENTLISTADMIN:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case GETSUBADMINMANAGEMENTLISTADMIN_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case GETSUBADMINMANAGEMENTLISTADMIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_GETSUBADMINMANAGEMENTLISTADMIN:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_GETSUBADMINMANAGEMENTLISTADMIN:
            return (state = initialState);
        default:
            return state;
    }
};
